import { useEffect, useRef } from 'react';
import { get } from 'lodash';
import { getCLS, getFID, getLCP } from 'web-vitals';

let spaHasNotInitiated = true;
let needFirstClsScore = true;

function sendToAnalytics(pageType) {
	return (metric) => {
		if (metric.name === 'CLS') {
			if (!needFirstClsScore) return;
			needFirstClsScore = false;
		}

		const metaData =
			metric.name === 'CLS'
				? get(metric, 'entries.0.sources', []).map((shift) => ({
						nodeData: get(shift, 'node.data'),
						nodeName: get(shift, 'node.nodeName'),
						nodeClassName: get(shift, 'node.className'),
						parentNodeClassName: get(shift, 'node.parentNode.className'),
						currentRect: shift.currentRect,
						previousRect: shift.previousRect,
					}))
				: undefined;

		const data = {
			metric: metric.name,
			value: metric.value,
			metaData,
			pageType,
		};
		const blob = new Blob([JSON.stringify(data)], { type: 'text/plain' });
		navigator.sendBeacon('/api/analytics/corewebvitals', blob);
	};
}

/**
 * Hook replacement for withCoreWebVitalMetrics from @sparefoot/react-core/decorators.
 *
 * Usage:
 *   useCoreWebVitalMetrics(pageType);
 */
export default function useCoreWebVitalMetrics(pageType) {
	const hasRun = useRef(false);

	useEffect(() => {
		if (
			typeof window !== 'undefined' &&
			navigator &&
			navigator.sendBeacon &&
			pageType &&
			spaHasNotInitiated &&
			!hasRun.current
		) {
			hasRun.current = true;
			getCLS(sendToAnalytics(pageType), true);
			getFID(sendToAnalytics(pageType));
			getLCP(sendToAnalytics(pageType));
			spaHasNotInitiated = false;
		}
	}, [pageType]);
}
